"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contextToOptions = void 0;
const contextToOptions = ({ version, } = {}) => ({
    context: {
        protocols: {
            event_version: version ?? 1,
        },
    },
});
exports.contextToOptions = contextToOptions;
//# sourceMappingURL=context-to-options.js.map